import { render } from "./EditableProfileName.vue?vue&type=template&id=c642fd10&scoped=true"
import script from "./EditableProfileName.vue?vue&type=script&lang=js"
export * from "./EditableProfileName.vue?vue&type=script&lang=js"

import "./EditableProfileName.vue?vue&type=style&index=0&id=c642fd10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c642fd10"]])

export default __exports__